import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { QuestionVoucherCheckInPeriodAvailable } from "./check-in-period-available/check-in-period-available";
import { QuestionVoucherIntervalPrepDates } from "./interval-prep-dates/interval-prep-dates";
import { QuestionVoucherLimitType } from "./voucher-limit-type/voucher-limit-type";

export const QuestionVoucherUsageRestrictions = () => {
	const title = "宿泊券の利用制限";
	const guide = "宿泊券ではチェックイン可能な期間や、購入してから数日後に使えるようになる設定ができます。";

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<>
					<QuestionVoucherLimitType />
					<QuestionVoucherCheckInPeriodAvailable />
					<QuestionVoucherIntervalPrepDates />
				</>
			}
		/>
	);
};

QuestionVoucherUsageRestrictions.displayName = "QuestionVoucherUsageRestrictions";
